export default function () {
  return {
    versoes: {
      data: [],
    },
    versao: {},
  };
}
